<template>
  <div class="bgku">
    <div class="row items-center">
      <div class="col-11 col-md-4 fixed-center">

        <div class="putihTrans formLogin shadow-5">
          <br>
            <!-- <q-img src="img/marinad.png" /> -->
            <!-- <hr />
            <br /> -->

            <div v-if="pesanError">
              <div  class="alertku shadow-2">
                <strong>Warning!</strong> {{ pesanError }}.

              </div>
              <br>
            </div>

            <form @submit.prevent="btn_regis()">
                <span class="h_lable">Nama Lengkap</span>
                <q-input v-model="form.nama" color="purple-12" outlined :dense="true" class="bg-white margin_input" />

                <span class="h_lable">Email</span>
                <q-input v-model="form.email" color="purple-12" outlined :dense="true" class="bg-white margin_input" /> 

                <span class="h_lable">Nomor HP</span>
                <q-input v-model="form.hp" color="purple-12" outlined :dense="true" class="bg-white margin_input" /> 

                <span class="h_lable">Username</span>
                <q-input v-model="form.username" color="purple-12" outlined :dense="true" class="bg-white margin_input" />

                <span class="h_lable">Password</span>
                <q-input v-model="form.password" color="purple-12" type="password" outlined :dense="true" class="bg-white margin_input" />

                <span class="h_lable">Konfirmasi Password</span>
                <q-input v-model="form.konfirmasiPassword" color="purple-12" type="password" outlined :dense="true" class="bg-white margin_input" />

                <!-- <span class="h_lable">Kelompok Pengguna</span>
                <q-select outlined v-model="form.menu_klp" color="purple-12" :options="list_level" option-label="uraian" option-value="id" :dense="true" /> -->
              <!-- <q-input v-model="user.username" outlined square color="purple-12" :dense="true" class="bg-white" placeholder="Username">
                <template v-slot:prepend>
                  <q-icon color="purple-12" name="account_circle" />
                </template>
              </q-input>
              <br />

              <q-input
                 v-model="user.password"
                outlined
                square
                :dense="true"
                class="bg-white"
                color="purple-12"
                placeholder="Password"
                type="password"
              >
                <template v-slot:prepend>
                  <q-icon color="purple-12" name="vpn_key" />
                </template>
              </q-input> -->
              <br />

              <q-btn type="submit" no-caps push class="full-width q-mb-xs" color="purple-12" label="Registrasi" />
            </form>
            <div class="row q-mt-sm q-mb-sm">
            <div class="col-5 text-left" style="padding-top: 5px;">
                <span style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 14px; color: #C039FF;">Sudah Punya Akun ?</span>
            </div>
            <div class="col-7 text-right">
                <q-btn no-caps to="/login" flat style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 14px; color: #6C91BF; font-weight: 600;" class="btn--no-hover" label="Login" />
            </div>
          </div>
            <hr>
            <div class="transAbu text-center" style="border-radius: 5px;">
              <span class="h_fotter_title text-center">Copyright : DPPPA Kabupaten Konawe Selatan</span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Joi from "joi";
  const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
    password: Joi.string().min(6).required(),
  });
export default {
  name: 'LoginPage',
  data : function(){
      return {
          pesanError: '',
          form : {
            id : '',
            nama : '',
            hp : '',
            email : '',
            username : '',
            password : '',
            konfirmasiPassword : '',
            menu_klp : '',
        },

          url : {
            REGIS_URL : this.$store.state.url.URL_APP + "auth/registrasi"
          }
      }
    },
    watch: {
      user: {
          handler() {
              this.pesanError = "";
          },
          deep: true
      }
    },
    methods: {

        btn_regis: function() {
      this.pesanError = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            // const body = {
            //   username: this.form.username,
            //   password: this.form.password
            // };
            // this.signingUp = true;

            fetch(this.url.REGIS_URL, {
                method: "POST",
                body: JSON.stringify(this.form),
                headers: {
                    "content-type": "application/json"
                }
            }).then((response) => {
                // this.signingUp = false;
                if (response.ok) {
                    // this.Notify('Sukses Registrasi User', 'purple-12', 'check_circle_outline');
                    // this.getView();
                    // this.$router.push('/login');
                    // return response.json();
                    this.pesanError = "Registrasi Sukses, Silahkan Login!";
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                // this.signingUp = false;
                this.pesanError = error.message;
              }, 1000);
            });
        }else{
          console.log("Tidak Valid");

        }

    },

    validUser : function(){
      if (this.form.password !== this.form.konfirmasiPassword) {
        this.pesanError = " Password dan Konfirmasi Password harus sama.! ";
          // this.Pesan('Password dan Confirm Password harus sama.!', 'accent', 'clear');
          return false;
      }
      // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
      // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
      const body = {
              username: this.form.username,
              password: this.form.password
      };

      const result = schema.validate(body);

      console.log(result.error)

      if (result.error == null || result.error ==undefined) {
          return true;
      }

      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.pesanError = "Username tidak valid (Min : 6 dan Max : 14 Karakter)";
        // this.Notify('Username tidak valid (Min : 6 dan Max : 14 Karakter)', 'accent', 'clear');
      } else {
          // this.Notify('Password tidak valid (Min : 6 Karakter)', 'accent', 'clear');
          this.pesanError = "Password tidak valid (Min : 6 Karakter)";
        //   console.log(result.error);
      }
      return false;
    },

    Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },

  },
  mounted() {
  }
}
</script>